/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RemoveUsersFromPooledOrgOperationStatus { 
    total_users_to_be_removed?: Array<string>;
    users_failed_to_remove?: Array<string>;
    users_successfully_removed?: Array<string>;
}

